import React from 'react'

import { useFormField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { TValidationType } from 'cng-common/features/form/models'
import { Tooltip } from 'core-components/library/tooltip'

import { OnboardingPhoneEditor } from './OnboardingPhoneEditor'

interface IProps {
  formKey: string
  label: string
  isDisabled?: boolean
  isRequired?: boolean
  isVisible?: boolean
  phoneCodeValue: string
  phoneNumberValue: string
  phoneCodeFieldName: string
  phoneNumberFieldName: string

  onPhoneNumberChange?: (value: string) => void
  onPhoneCodeChange?: (value: string) => void

  onPhoneNumberValidate?: (value: string) => Promise<string>
  onPhoneCodeValidate?: (value: string) => Promise<string>
  validationType?: TValidationType
}

export const OnboardingFormPhoneEditor = ({
  isDisabled,
  isVisible = true,
  isRequired,
  formKey,
  phoneNumberFieldName,
  onPhoneNumberChange,
  phoneCodeFieldName,
  onPhoneCodeValidate,
  onPhoneCodeChange,
  onPhoneNumberValidate,
  phoneNumberValue,
  phoneCodeValue,
  label,
}: IProps) => {
  const {
    value: formPhoneNumber,
    handleChange: handlePhoneNumberChange,
    validationMessage: validatePhoneNumberMessage,
  } = useFormField<string>({
    defaultValue: phoneNumberValue,
    field: phoneNumberFieldName,
    formKey: formKey,
    onChange: onPhoneNumberChange,
    onValidate: onPhoneNumberValidate,
    isDisabled,
    isRequired,
    isVisible,
    validationType: ValidationType.ONCHANGE,
  })
  const {
    value: formPhoneCode,
    handleChange: handlePhoneCodeChange,
    validationMessage: validationPhoneCodeMessage,
  } = useFormField<string>({
    defaultValue: phoneCodeValue,
    field: phoneCodeFieldName,
    formKey: formKey,
    onChange: onPhoneCodeChange,
    onValidate: onPhoneCodeValidate,
    isDisabled,
    isRequired,
    validationType: ValidationType.ONCHANGE,
  })

  return isVisible ? (
    <Tooltip
      tipContent={() => (
        <div>
          {validationPhoneCodeMessage ? <div>Phone code: {validationPhoneCodeMessage}</div> : null}
          {validatePhoneNumberMessage ? (
            <div>Phone number: {validatePhoneNumberMessage}</div>
          ) : null}
        </div>
      )}
      disabled={isDisabled || !(validatePhoneNumberMessage || validationPhoneCodeMessage)}
    >
      <OnboardingPhoneEditor
        isDisabled={isDisabled}
        label={label}
        codeValue={formPhoneCode}
        phoneValue={formPhoneNumber}
        onCodeChange={handlePhoneCodeChange}
        onPhoneChange={handlePhoneNumberChange}
      />
    </Tooltip>
  ) : null
}
